import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TransactionStatePublic } from '@app/core/resources/transaction-state-public';
import { StatesService } from '@app/core/services/states.service';
import { TransactionStatePublicService } from '@app/core/services/transaction-state-public.service';
import { Transaction } from '@app/transactions/transaction';
import { filter } from 'rxjs/operators';
import { TransactionPublicHelper } from './transaction-public.helper';
import { LanguageConfigService } from '@app/wiki/language-config.service';
import { SeoService } from '@app/core/services/seo.service';
import { OgService } from '@app/core/services/og.service';
import { SeverityEnum } from '../../../../ui/shared/enums/severity.enum';

@Component({
    selector: 'app-transaction-states',
    templateUrl: './transaction-states.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./transaction-states.component.scss']
})
export class TransactionStatesComponent {
    public transactionStatePublic: TransactionStatePublic = new TransactionStatePublic();
    private transactionPublicHelper: TransactionPublicHelper = new TransactionPublicHelper();
    public transaction: Transaction = new Transaction();
    public transaction_state_form: FormGroup;
    public showStateTransaction: boolean = false;
    public severityEnum: typeof SeverityEnum = SeverityEnum;

    public constructor(
        public statesService: StatesService,
        private formBuilder: FormBuilder,
        private transactionStatePublicService: TransactionStatePublicService,
        private changeDetectorRef: ChangeDetectorRef,
        private activatedRoute: ActivatedRoute,
        private languageConfigService: LanguageConfigService,
        private seoService: SeoService,
        private ogService: OgService
    ) {
        this.transaction_state_form = this.formBuilder.group({
            mid: ['', [Validators.required]],
            email: ['', [Validators.required]]
        });
        this.languageConfigService
            .setActivatedRoute(this.activatedRoute)
            .updateLanguageFromUrl('transaction-states')
            .subscribe(() => {
                this.seoService.addTitle('Mi pedido | Saldoar');
                this.seoService.addCanonical('transaction-states');
                this.ogService.addOpenGraphMetadata({ url: 'transaction-states' });
                this.seoService.addMetaName('keywords', 'pedido, consulta, estado');
                this.seoService.addMetaName('description', 'Consulta sobre el estado de tu pedido aquí.');
            });
    }

    public getToken(): void {
        if (this.transaction_state_form.invalid) {
            return;
        }
        this.transactionStatePublic.attributes.mid = this.trimString(this.transaction_state_form.value.mid);
        this.transactionStatePublic.attributes.email = this.trimString(this.transaction_state_form.value.email);
        this.transactionStatePublic.save().subscribe(
            () => {
                this.getTransactionStatePublic(this.transactionStatePublic.attributes.token);
                this.showStateTransaction = true;
                this.transactionStatePublic = new TransactionStatePublic();
            },
            (error: HttpErrorResponse) => {
                this.transactionStatePublic.is_saving = false;
                this.changeDetectorRef.detectChanges();
                throw error;
            }
        );
    }

    private trimString(str: string): string {
        return str.replace(/^\s+|\s+$/g, '');
    }

    private getTransactionStatePublic(token: string): void {
        this.transactionStatePublicService
            .get(token, { include: ['states', 'system1', 'system2'] })
            .pipe(filter((transactionStatePublic: TransactionStatePublic) => transactionStatePublic.source !== 'new'))
            .subscribe(
                (transactionStatePublic) => {
                    this.transaction = this.transactionPublicHelper.transformTransactionStateToTransaction(transactionStatePublic);
                    this.changeDetectorRef.detectChanges();
                },
                (error: HttpErrorResponse) => {
                    console.log('error');
                    throw error;
                }
            );
    }
}
